export default "__VITE_ASSET__UQ_bzfzK__"